import { DistanceUnit } from "@api/graphql/generated/generated-types";
import { metersToMiles } from "@src/common/lib/NumberUtils";

const MILES_TO_KM = 1.609344;

export const metersToKilometers = (meters: number): number => {
  return meters / 1000;
};

export const formatDistance = (
  meters: number,
  distanceUnit: DistanceUnit
): string => {
  if (!Number.isFinite(meters)) {
    return "";
  }

  if (distanceUnit === DistanceUnit.Kilometer) {
    return `${metersToKilometers(meters).toFixed(1)} km`;
  }

  return `${metersToMiles(meters).toFixed(1)} mi`;
};

/** Convert miles (from API) to display value based on courier's distance unit */
export const milesToDisplay = (
  miles: number,
  distanceUnit: DistanceUnit
): number => {
  if (distanceUnit === DistanceUnit.Kilometer) {
    return parseFloat((miles * MILES_TO_KM).toFixed(2));
  }
  return miles;
};

/** Convert display value back to miles (for API) based on courier's distance unit */
export const displayToMiles = (
  value: number,
  distanceUnit: DistanceUnit
): number => {
  if (distanceUnit === DistanceUnit.Kilometer) {
    return parseFloat((value / MILES_TO_KM).toFixed(6));
  }
  return value;
};

/** Convert a "per mile" rate (from API) to "per km" for display */
export const perMileToDisplay = (
  ratePerMile: number,
  distanceUnit: DistanceUnit
): number => {
  if (distanceUnit === DistanceUnit.Kilometer) {
    return parseFloat((ratePerMile / MILES_TO_KM).toFixed(6));
  }
  return ratePerMile;
};

/** Convert a "per km" display rate back to "per mile" for API */
export const displayToPerMile = (
  ratePerDisplayUnit: number,
  distanceUnit: DistanceUnit
): number => {
  if (distanceUnit === DistanceUnit.Kilometer) {
    return parseFloat((ratePerDisplayUnit * MILES_TO_KM).toFixed(6));
  }
  return ratePerDisplayUnit;
};
